import { ADDRESS_ENDPOINTS } from "./endpoints";
import { apiDelete } from "../shared";
import { DEFAULT_API_OPTIONS } from "./constants";

export default async function deleteAddress(addressId: string): Promise<void> {
  await apiDelete<void>(ADDRESS_ENDPOINTS.DELETE(addressId), DEFAULT_API_OPTIONS);
}
